// DeadlineFilterBar.js — refactor 2026-05-21.
//
// Chip bar urgency + dropdown drill-down theo loại deadline.
// Dùng chung cho StudentProjectTable + InstitutionalProjectTable.
//
// Props:
//   - chip:     "all" | "overdue" | "soon7" | "soon30"
//   - setChip:  setter
//   - kindKey:  "all" hoặc kind.key trong DEADLINE_KINDS_*
//   - setKindKey: setter
//   - kinds:    DEADLINE_KINDS_SR hoặc DEADLINE_KINDS_IR
//   - counts:   { all, overdue, soon7, soon30 } — số row khớp mỗi chip
//                (đã filter theo kindKey hiện tại). Caller tính qua useMemo.

import React from "react";
import { Box, Button, Select, MenuItem, Typography, Chip } from "@material-ui/core";
import { Warning, Schedule, Event, Clear } from "@material-ui/icons";

const CHIP_DEFS = [
  { key: "all",     label: "Tất cả",        icon: null,     color: "default" },
  { key: "overdue", label: "Quá hạn",       icon: <Warning fontSize="small" />,  color: "secondary" },
  { key: "soon7",   label: "≤7 ngày",       icon: <Schedule fontSize="small" />, color: "primary" },
  { key: "soon30",  label: "≤30 ngày",      icon: <Event fontSize="small" />,    color: "default" },
];

export default function DeadlineFilterBar({
  chip,
  setChip,
  kindKey,
  setKindKey,
  kinds,
  counts,
}) {
  const isActive = (k) => (chip || "all") === k;
  const hasFilter = (chip && chip !== "all") || (kindKey && kindKey !== "all");

  return (
    <Box
      display="flex"
      alignItems="center"
      flexWrap="wrap"
      gridGap={8}
      padding="8px 12px"
      marginBottom={1}
      bgcolor="#fafafa"
      border="solid 1px #e0e0e0"
      borderRadius={4}
    >
      <Typography variant="caption" style={{ fontWeight: 600, marginRight: 4 }}>
        Bộ lọc deadline:
      </Typography>

      {CHIP_DEFS.map((c) => {
        const active = isActive(c.key);
        const count = counts?.[c.key];
        return (
          <Chip
            key={c.key}
            size="small"
            icon={c.icon || undefined}
            label={
              count !== undefined && count !== null
                ? `${c.label} (${count})`
                : c.label
            }
            clickable
            color={active ? (c.color === "default" ? "primary" : c.color) : "default"}
            variant={active ? "default" : "outlined"}
            onClick={() => setChip(c.key)}
            style={{ fontWeight: active ? 600 : 400 }}
          />
        );
      })}

      <Box flexGrow={1} />

      <Typography variant="caption" color="textSecondary">
        Loại:
      </Typography>
      <Select
        value={kindKey || "all"}
        onChange={(e) => setKindKey(e.target.value)}
        variant="outlined"
        margin="dense"
        style={{ minWidth: 200, height: 32 }}
      >
        <MenuItem value="all">Tất cả loại deadline</MenuItem>
        {kinds.map((k) => (
          <MenuItem key={k.key} value={k.key}>
            {k.label}
          </MenuItem>
        ))}
      </Select>

      {hasFilter && (
        <Button
          size="small"
          variant="text"
          startIcon={<Clear fontSize="small" />}
          onClick={() => {
            setChip("all");
            setKindKey("all");
          }}
        >
          Xoá lọc
        </Button>
      )}
    </Box>
  );
}
